import React, { ReactElement } from 'react';
import { Control, Controller } from 'react-hook-form';
import {
  ToggleButtonGroup,
  ToggleButtonGroupOptions,
} from '../../ToggleButtonGroup';

export interface ControlledToggleButtonGroupProps<TValue> {
  control: Control;
  name: string;
  options: ToggleButtonGroupOptions<TValue>;
  className?: string;
  defaultValue?: TValue;
  disabled?: boolean;
  customOnChange?: (value: TValue) => void;
}

export const ControlledToggleButtonGroup = <TValue,>({
  control,
  name,
  options,
  className,
  defaultValue,
  disabled,
  customOnChange,
}: ControlledToggleButtonGroupProps<TValue>): ReactElement => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ onChange, value }) => (
        <ToggleButtonGroup
          className={className}
          disabled={disabled}
          options={options}
          value={value as TValue}
          onChange={(nextValue) => {
            customOnChange?.(nextValue);
            onChange(nextValue);
          }}
        />
      )}
    />
  );
};
